import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

class DOEService {
    public async getDoePublies(payload: FiltreDoe): Promise<any> {
        return http.get(Routes.DoeRoutes.RecupererDoePublies(), {params: payload});
    }

    public async getPdfDoe(id: number): Promise<any> {
        return http.get(Routes.DoeRoutes.RecupererPdfDoe(id), {responseType: 'arraybuffer'});
    }

}

export interface FiltreDoe{
    chantierIds?: number[];
    libelleDoe?: string;
    page?: number;
    sort?: string;
}

export default new DOEService();
